module.exports = "/assets/data/b348840bbf828129fa31c6926a6d5592-IG1.data.json";